import { render, staticRenderFns } from "./ForgotPasswordSecure.vue?vue&type=template&id=4683cb1e"
import script from "./ForgotPasswordSecure.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSecure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports